import { useEffect, useState } from "react";

export const LoadingScreen = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const seen = sessionStorage.getItem("wc_loaded");
    if (!seen) {
      setShow(true);
      sessionStorage.setItem("wc_loaded", "1");
      const t = setTimeout(() => setShow(false), 1500);
      return () => clearTimeout(t);
    }
  }, []);

  if (!show) return null;

  return (
    <div
      className="fixed inset-0 z-[200] bg-black flex items-center justify-center"
      data-testid="loading-screen"
    >
      <div
        className="wc-loading-word wc-heading text-4xl md:text-6xl tracking-[0.25em] text-white"
        style={{ fontFamily: "'Bebas Neue', sans-serif" }}
      >
        WRONGCONCEPTION
      </div>
    </div>
  );
};

export default LoadingScreen;
